export const DOCUMENT_STATUS = {
  STATUS_ON_HOLD: 'en attente',
  STATUS_ANALYSIS: 'analyse',
  STATUS_TREATED: 'traité',
  STATUS_ERROR: 'erreur'
}

export const DOCUMENT_TYPES = {
  TYPE_BUY: 1,
  TYPE_SELL: 2,
  TYPE_COSTS: 3,
  TYPE_KBIS:4,
  TYPE_RIB:5,
}

export const DOCUMENT_TYPE_LABELS = {
  [DOCUMENT_TYPES.TYPE_BUY]: "Facture d’achat",
  [DOCUMENT_TYPES.TYPE_SELL]: "Facture de vente",
  [DOCUMENT_TYPES.TYPE_COSTS]: "Note de frais",
  [DOCUMENT_TYPES.TYPE_KBIS]: "KBIS",
  [DOCUMENT_TYPES.TYPE_RIB]: "RIB"
};